<template>
    <div>
        <app-row v-if="computedCatalog.length === 0">
            <app-col cols="12">
                <v-alert type="info" text outlined class="mb-4">
                    No hay acciones configuradas. Haz clic en "Añadir acción" para crear una.
                </v-alert>
            </app-col>
        </app-row>

        <div
            v-for="(action, index) in computedCatalog"
            :key="index"
            class="action-row"
        >
            <app-row>
                <app-col cols="2">
                    <v-text-field
                        v-model="action.code"
                        label="Código"
                        outlined
                        dense
                        hide-details
                        @input="emitUpdate"
                    />
                </app-col>

                <app-col cols="1">
                    <v-text-field
                        v-model="action.workflow_id"
                        label="WF ID"
                        outlined
                        dense
                        hide-details
                        @input="emitUpdate"
                    />
                </app-col>

                <app-col cols="4">
                    <v-text-field
                        v-model="action.description"
                        label="Descripción"
                        outlined
                        dense
                        hide-details
                        @input="emitUpdate"
                    />
                </app-col>

                <app-col cols="2" class="d-flex align-center">
                    <v-checkbox
                        v-model="action.autoSaveAfter"
                        label="Auto-guardar"
                        hide-details
                        dense
                        @change="emitUpdate"
                    />
                </app-col>

                <app-col cols="2" class="d-flex align-center">
                    <v-checkbox
                        v-model="action.list_action"
                        label="Acción lista"
                        hide-details
                        dense
                        @change="emitUpdate"
                    />
                </app-col>

                <app-col cols="1" class="d-flex align-center justify-center">
                    <v-btn icon color="error" @click="removeAction(index)">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </app-col>
            </app-row>

            <app-row v-if="action.list_action" class="mt-1">
                <app-col cols="3" offset="2">
                    <v-text-field
                        v-model="action.icon"
                        label="Icono"
                        outlined
                        dense
                        hide-details
                        prepend-inner-icon="mdi-emoticon-outline"
                        :append-icon="action.icon || 'mdi-help'"
                        @input="emitUpdate"
                    />
                </app-col>
                <app-col cols="3">
                    <v-text-field
                        v-model="action.hover_text"
                        label="Tooltip"
                        outlined
                        dense
                        hide-details
                        @input="emitUpdate"
                    />
                </app-col>
            </app-row>
        </div>

        <app-row>
            <app-col cols="12" class="mt-2">
                <v-btn @click="addAction" color="primary" outlined>
                    <v-icon left>mdi-plus</v-icon>
                    Añadir acción
                </v-btn>
            </app-col>
        </app-row>
    </div>
</template>

<script>
import AppRow from "@/components/layout/AppRow.vue";
import AppCol from "@/components/layout/AppCol.vue";

export default {
    name: "ActionsCatalogEditor",
    components: { AppRow, AppCol },
    props: {
        value: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        computedCatalog: {
            get() {
                // Devuelve una copia para evitar mutar directamente el prop
                return Array.isArray(this.value) ? [...this.value] : [];
            },
            set(newVal) {
                this.$emit("input", newVal);
            }
        }
    },
    methods: {
        addAction() {
            const updated = [
                ...this.computedCatalog,
                { code: "", description: "", workflow_id: "", autoSaveAfter: false, list_action: false, icon: "", hover_text: "" }
            ];
            this.computedCatalog = updated;
        },
        removeAction(index) {
            const updated = this.computedCatalog.filter((_, i) => i !== index);
            this.computedCatalog = updated;
        },
        emitUpdate() {
            // Vuelve a emitir el array actualizado
            this.computedCatalog = [...this.computedCatalog];
        }
    }
};
</script>

<style scoped>
.action-row {
    margin-bottom: 12px;
    padding: 12px;
    background-color: white;
    border-radius: 4px;
    border: 1px solid #e0e0e0;
}
</style>
